import _cloneDeep from 'lodash/cloneDeep';

/**
 * GeoService class.
 * Use this service to handle Geo configs.
 */
export default class GeoService {
    /**
     * @param {RemoteConfigService} RemoteConfigService - Service to get configuration from API/server
     * @constructor
     * @ngInject
     */
    constructor(RemoteConfigService) {
        this.RemoteConfigService = RemoteConfigService;
        this.data = _cloneDeep(this.RemoteConfigService.getServiceConfig('geo'));
        this.earthRadius = 6371e3; // metres
    }

    /**
     * Get list of coordinates
     * @returns {Object} Return all coordinates configs
     */
    getCoordsList() {
        return this.data;
    }

    /**
     * Get coordinates by defined key
     * @param {string} key - Coordinates key
     * @returns {{}|null} Return coordinates config or null if absent
     */
    getCoordsByKey(key) {
        return this.data[key] || null;
    }

    getDistanceBetweenCoords(p1Lat, p1Lng, p2Lat, p2Lng) {
        const R = this.earthRadius;

        function toRadians(deg) {
            const multiplier = Math.PI / 180;
            return deg * multiplier;
        }

        function halfOf(value) {
            return value / 2;
        }

        const phi1 = toRadians(p1Lat);
        const phi2 = toRadians(p2Lat);
        const deltaPhi = toRadians(p2Lat - p1Lat);
        const deltaLambda = toRadians(p2Lng - p1Lng);

        const a1 = Math.sin(halfOf(deltaPhi)) * Math.sin(halfOf(deltaPhi));
        const a2 = Math.cos(phi1) * Math.cos(phi2) *
            Math.sin(halfOf(deltaLambda)) * Math.sin(halfOf(deltaLambda));

        const a = a1 + a2;

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }
}



// WEBPACK FOOTER //
// ./app/services/geo/geo.service.js